export default __webpack_public_path__ + "static/mob-img-0a8a2a198f7aaba7a74984a18b4a5012.png";